var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconMoreInfo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_9364_16409)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11 14.6654V10.9987M11 7.33203H11.0092M20.1667 10.9987C20.1667 16.0613 16.0627 20.1654 11 20.1654C5.93743 20.1654 1.83337 16.0613 1.83337 10.9987C1.83337 5.93609 5.93743 1.83203 11 1.83203C16.0627 1.83203 20.1667 5.93609 20.1667 10.9987Z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_9364_16409"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 22,
    fill: "currentColor"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMoreInfo);
export default __webpack_public_path__ + "static/media/icon-more-info.47523ba38c8b3ee7df041a936355d2d9.svg";
export { ForwardRef as ReactComponent };